$(function () {
    var vacanciesTemplate = $(".vacancies-template");

    if (vacanciesTemplate.length)
    {
        // Get the static containers that will always be present.
        var apiListWrap = $(".api-list"); // Outer container that holds the overlay, list and pager
        var apiListOverlay = $(".api-list-wrap .overlay"); // The list overlay
        var apiList = $(".api-list"); // Contains all the data attributes
        var apiListPager = $(".api-list-pager"); // Pager for the list

        // Search
        var searchInput = $(".api-search-text");

        // Create the initial pager
        VacancyRepositoryRebuildPager();

        $('.api-search-button').click(function () {
            $(apiList).data("list-page", 0); // Reset the page number to 0

            $('.vacancy-search-option select').val('');

            $('.api-search-button').addClass('mcdisabled');

            VacancyRepositoryListUpdate(); // Update the list
        });

        $('.vacancy-search-option select').change(function () {

            $(apiList).data("list-page", 0); // Reset the page number to 0

            $('.api-search-button').removeClass('mcdisabled');

            // Update the list
            VacancyRepositoryListUpdate();
        });

        // Fully update the list
        function VacancyRepositoryListUpdate() {

            // Turn on the overlay
            $(apiListOverlay).addClass("active");

            // Get all the variables for the request
            var pagerUrl = $(apiList).data("search-url");
            var listUrl = $(apiList).data("list-url");
            var listPage = $(apiList).data("list-page");
            var listPageSize = $(apiList).data("list-pagesize");
            var listCount = $(apiList).data("list-count");

            var selRoleType = $('#roletype').val();
            var selOffice = $('#office').val();

            // Create the request string
            var url = listUrl + "?api=true" +
                (listPage > 0 ? "&page=" + listPage : "") +
                (listPageSize > 0 ? "&pagesize=" + listPageSize : "") +
                (selRoleType > 0 ? "&roletype=" + selRoleType : "") +
                (selOffice > 0 ? "&office=" + selOffice : "");

            $.get(url, function (data) {

                // Process the data 

                // Remove the existing items
                $(apiList).children().remove();

                // Get the latest count from the data
                var newFullCount = $('<div/>').html(data).find('.vacancies-list-count-update').data('list-count');
                newFullCount = newFullCount == undefined ? 0 : newFullCount;
                $(apiList).data("list-count", newFullCount);

                if (newFullCount == 0) { // If there is no data then activate the general message
                    data = "<div class=\"general-no-items-message active\">There are currently no vacancies matching that criteria.</div>";
                    $(apiList).html(data);
                } else {
                    // Get all items from the data
                    var vacancyList = $('<div/>').html(data).find('.vacancy');

                    // Update the list with the new items
                    $(apiList).html(vacancyList);
                }

                // Move to the top of the list
                $('html, body').animate({
                    scrollTop: $('.vacancies-search-row').offset().top - 180
                }, 500);

                // Rebuild the pages
                VacancyRepositoryRebuildPager();

                // Remove the overlay
                $(apiListOverlay).removeClass("active");
            });
        }

        /* ##### PAGER ##### */

        // When a pager button is clicked
        function VacancyRepositoryPageLinkClick() {

            $(apiListOverlay).addClass("active"); // Turn on the overlay

            // Get the page ID for the link that was clicked
            var pagerPageLink = this;
            var pagerPage = $(pagerPageLink).data("list-page");

            $(apiList).data("list-page", pagerPage); // Update the page data attribute with the one clicked

            VacancyRepositoryListUpdate();
        }

        // Rebuilds the pager
        function VacancyRepositoryRebuildPager() {
            // Get all the variables required to build the pager
            var listPage = $(apiList).data("list-page");
            var listPageSize = $(apiList).data("list-pagesize");
            var listCount = $(apiList).data("list-count");

            // Clear the pager
            $(apiListPager).html("");

            // If we have zero items then we need to hide the pager
            if (listCount == 0) {
                $(apiListPager).hide();
            } else {
                $(apiListPager).show();

                // Get the maximum pages
                var maxPages = Math.ceil(listCount / listPageSize);

                if (maxPages > 1) {
                    // Create the first link
                    //if (listPage > 1) {
                    //    $(apiListPager).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link\" data-list-page=\"0\"><span><i class=\"fas fa-chevron-double-left\"></i></span></a>");
                    //}

                    // Create previous page link
                    if (listPage > 0) {
                        $(apiListPager).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link page-prev\" data-list-page=\"" + (listPage - 1) + "\"><span><i class=\"fas fa-chevron-left\"></i></span></a>");
                    }

                    // Create the previous dots link
                    var previousDotsPage = listPage == maxPages - 1 ? listPage - 3 : listPage - 2;
                    if (previousDotsPage >= 0) {
                        $(apiListPager).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link\" data-list-page=\"" + previousDotsPage + "\"><span>...</span></a>");
                    }

                    // Create the three middle elements
                    // We need to get the starting number for the 3 pager item, this is not always 1
                    var startingNumber = listPage == 0 ? 0 : listPage - 1;

                    // If we are on the last page we need to offset the start by 2, BUT only if we are not also next to the first page
                    startingNumber = listPage > 1 && listPage == (maxPages - 1) ? listPage - 2 : startingNumber;

                    // Loop through 3 times from the starting number and output the correct links
                    for (var pc = startingNumber; pc <= startingNumber + 2; pc++) {
                        // Only if the current number is less than the max pages
                        if (pc < maxPages) {
                            $(apiListPager).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link" + (listPage == pc ? " active" : "") + "\" data-list-page=\"" + pc + "\"><span>" + (pc + 1) + "</span></a>");
                        }
                    }

                    // Create the next dots link
                    var nextDotsPage = listPage == 0 ? listPage + 3 : listPage + 2;
                    if (nextDotsPage <= maxPages - 1) {
                        $(apiListPager).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link\" data-list-page=\"" + nextDotsPage + "\"><span>...</span></a>");
                    }

                    // Create the next link
                    if (listPage < maxPages - 1) {
                        $(apiListPager).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link page-next\" data-list-page=\"" + (listPage + 1) + "\"><span><i class=\"fas fa-chevron-right\"></i></span></a>");
                    }

                    // Create the last link
                    //if (listPage < maxPages - 2) {
                    //    $(apiListPager).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link\" data-list-page=\"" + (maxPages - 1) + "\"><span><i class=\"fas fa-chevron-double-right\"></i></span></a>");
                    //}
                }

                // Rebind clicks
                $(apiListPager).find(".page-link").click(VacancyRepositoryPageLinkClick);
            }
        }
    }
});